import React, {useCallback, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {changePlaneOparetionsModalValue} from "../../store/reducers/ModalReducer";
import GoBack from "../../Icons/Actions/GoBack";
import "./PlaneOperations.css";
import {addPlaneOperationsThunk, deletePlaneOperationsThunk} from "../../store/PartThunks";
 import Search from "../../Icons/Search";
 import GoBackArrow from "../../Icons/Actions/GoBackArrow";
import {getModalPlaneOperation} from "../../selectors/modal-selector";
import {useLang} from "../../context/langProvider";
import {getOrder} from "../../selectors/order-selector";


const PlaneOperations = () => {
    const {getT} = useLang()
    const modalDt = useSelector(getModalPlaneOperation);
    return modalDt?.isOpen ? <Component getT={getT}/> : null;
};
const Component = ({getT}) => {
    const dispatch = useDispatch();
    const modalDt = useSelector(getModalPlaneOperation);
    const store = useSelector(getOrder);


    const [active, setActive] = useState({
        name: "",
        id: null
    });

    const parts = store?.part?.sort((a, b) => a.id - b.id);
    const operations = useMemo(()=>{
        return store?.plane_operations?.filter(item=> modalDt?.search ? item?.name.includes(modalDt.search) : true);
    }, [modalDt.search]);

    const close = useCallback( () => dispatch(changePlaneOparetionsModalValue("isOpen", false)), [dispatch]);

    const addPlaneOperation = (part_id, side) => dispatch(addPlaneOperationsThunk(part_id, active.id, side));
    const deletePlaneOperation = (part_id, side) => dispatch(deletePlaneOperationsThunk(part_id, active.id, side));
    const checkOperations = (part_id, side) => {
        const part = parts.find(e => Number(e.id) === Number(part_id));
        if (part.hasOwnProperty("plane_operations")) {
            const operations = part.plane_operations.filter(e => Number(e.id) === Number(active.id) && e.side === side);
            return operations.length > 0;
        }

        return false;
    };
    return <div className="nightstands-wrapper modal-page plane-operations-modal">
        <div className="nightstands-container">
            <aside className="aside">

                <div className="goback">
                    <div onClick={() => close()}>
                        <GoBack/> <span className="goback-text">{getT("Назад")}</span>
                    </div>
                </div>
                <div className="plane-operation__search">
                    <div className="go-back-arrow" onClick={() => close()}>
                        <GoBackArrow/>
                    </div>
                    <div className="search-bar">
                        <div className="search-bar-field">
                            <Search/>
                            <input type="text"
                                   placeholder={getT("Поиск")}
                                   onChange={(event) => dispatch(changePlaneOparetionsModalValue("search", event.target.value))}
                                   value={modalDt.search}
                            />
                        </div>
                    </div>
                </div>
                <div className="aside-nav">
                    <h3 className="aside-nav-title">{getT("Обработки плоскости")}</h3>
                    <nav role="navigation">
                        {operations.map(e => {
                            return <div
                                className={"materials_nav_item plane_operations_nav_item " + (Number(active.id) === Number(e.id) ? "active" : "")}
                                onClick={() => {
                                    setActive((prev)=>{
                                        return {
                                            name: e?.name, id: e?.id
                                        }
                                    })
                                }}
                            >
                                <div className="plane_operations_item_image">
                                    <img src={"https://admin.ifurn.pro" + e.image} alt=""/>
                                </div>
                                <div className={"plane_operations_item_name"}>
                                    {e.name} <br/>
                                    <small>{getT("Код 1С")}: <b>{e.code_1c}</b></small>
                                </div>
                            </div>;
                        })}
                    </nav>
                </div>
            </aside>
            <div className="main_content">

                <div className="search-bar">
                    <div className="search-bar-field">
                        <Search/>
                        <input type="text"
                               placeholder={getT("Поиск")}
                               onChange={(event) => dispatch(changePlaneOparetionsModalValue("search", event.target.value))}
                               value={modalDt.search}
                        />
                    </div>
                </div>
                <div>
                    <h3 className="nightstands-content-title">{active.name}</h3>
                    <p className="nightstands-content-subtitle">
                        {active.id ? getT("Выберите детали для которых необходимо применить обработку") : getT("Выберите одну из доступных операций")}
                    </p>
                </div>
                <div className="card-container">
                    <div className="table-wrapper">
                        {active.id && <>
                            <div className="overflow-scrolled">
                                <table>
                                    <thead>
                                    <tr>
                                        <th scope="col">№</th>
                                        <th scope="col">{getT("Название")}</th>
                                        <th scope="col">{getT("Размеры")}</th>
                                        <th scope="col">{getT("Количество")}</th>
                                        <th scope="col">{getT("Лицевая")}</th>
                                        <th scope="col">{getT("Обратная")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {parts.map(e => {
                                        return <tr>
                                            <td>{e.id}</td>
                                            <td>{e.name}</td>
                                            <td>{e.x ?? e.x1 ?? e.x2} x {e.y ?? e.y1 ?? e.y2} x {e.z}</td>
                                            <td>{e.count}</td>
                                            <td>
                                                <label className={"form-input-checkbox-label"}
                                                       htmlFor={"plane_operations_side_f_" + e.id}>
                                                    <input type="checkbox"
                                                           checked={checkOperations(e.id, "f") ? "checked" : ""}
                                                           className={"form-input-checkbox"}
                                                           id={"plane_operations_side_f_" + e.id}
                                                           onChange={(event) => checkOperations(e.id, "f") ? deletePlaneOperation(e.id, "f") : addPlaneOperation(e.id, "f")}
                                                    />
                                                    <span> </span>
                                                </label>
                                            </td>
                                            <td>
                                                <label className={"form-input-checkbox-label"}
                                                       htmlFor={"plane_operations_side_bb_" + e.id}>
                                                    <input type="checkbox"
                                                           checked={checkOperations(e.id, "bb") ? "checked" : ""}
                                                           className={"form-input-checkbox"}
                                                           id={"plane_operations_side_bb_" + e.id}
                                                           onChange={(event) => checkOperations(e.id, "bb") ? deletePlaneOperation(e.id, "bb") : addPlaneOperation(e.id, "bb")}
                                                    />
                                                    <span> </span>
                                                </label>
                                            </td>
                                        </tr>;
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}


export default PlaneOperations;
